<template>
  <main-layout>
    <div class="paySuc" v-if="isShow">
      <div class="sucBox">
        <div class="pay">
          <img class="sucImg" src="/static/live/pay_done_icon@2x.png" alt="" />
          {{ $t("live.支付成功") }}！
        </div>
        <p class="payTime">{{ time }}s{{ this.isMeal ? $t("recruit.后自动进入招聘管理") : $t("live.后自动进入直播间")}}</p>
        <div class="payButtom">
          <span class="buttom1" @click="gotoPayList">{{
            $t("live.查看订单")
          }}</span>
          <span class="buttom2" @click="gotoLivePage">{{
            this.isMeal ? $t("recruit.招聘管理") : $t("live.进入直播间")
          }}</span>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
export default {
  metaInfo() {
    return {
      title: "MANA " + this.$t("live.支付成功"),
    };
  },
  components: {
    MainLayout,
  },
  data() {
    return {
      time: 3,
      plant: null,
      orderNo: null,
      liveId: null,
      isShow: false,
      timer: null,
      isMeal: false
    };
  },

  methods: {
    getPay() {
      this.$http.get("/api/bytedance/order/query?orderNo=" + this.orderNo + "&platform=" + this.plant).then((res) => {
        if (res.code == "OK") {
          if (res.data.orderStatusEnum == "SUCCESS") {
            this.isShow = true;
            this.timer = setInterval(() => {
              if (this.time <= 0) {
                clearInterval(this.timer);
                this.gotoLivePage();
                return;
              } else {
                this.time--;
              }
            }, 1000);
          }
        }
      });
    },
    gotoPayList() {
      clearInterval(this.timer);
      this.$router.push("/my/order");
    },
    gotoLivePage() {
      clearInterval(this.timer);
      if (this.isMeal) {
        this.$router.push("/MyRecruit?type=3")
      } else {
        if (
          /Safari/.test(navigator.userAgent) ||
          /Chrome/.test(navigator.userAgent)
        ) {
          this.$http.post("/api/bytedance/auth/" + this.liveId).then((res) => {
            if (res.code === "OK") {
              window.location.href = res.data;
            }
          });
        } else {
          this.$router.push("/live/livePage?id=" + this.liveId);
        }
      }
    },
  },

  created() {
    if (this.$route.query.type) {
      this.isMeal = true;
    }
    if (this.$route.query.weChatId) {
      this.liveId = this.$route.query.weChatId;
      this.isShow = true;
      this.timer = setInterval(() => {
        if (this.time <= 0) {
          clearInterval(this.timer);
          this.gotoLivePage();
          return;
        } else {
          this.time--;
        }
      }, 1000);
    } else {
      this.plant = this.$route.query.platform;
      this.orderNo = this.$route.query.order_no;
      this.liveId = this.$route.query.live_id;
      this.getPay();
    }
  },
  mounted() {},
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>
<style lang="stylus" scoped>
.paySuc {
  background: #fff;
  min-height: 70vh;
  padding-top: 80px;

  .sucBox {
    width: 80%;
    margin: 0 auto;
    text-align: center;

    .pay {
      height: 50px;
      font-size: 28px;
      font-weight: 600;
      color: #333333;
      line-height: 50px;

      .sucImg {
        width: 50px;
        height: 50px;
      }
    }

    .payTime {
      height: 21px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 21px;
      margin: 20px 0 52px 0;
    }

    .payButtom {
      font-size: 0;

      .buttom1 {
        display: inline-block;
        width: 144px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 1px solid #999999;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        box-sizing: border-box;
        margin-right: 30px;
        vertical-align: middle;
        cursor: pointer;
      }

      .buttom2 {
        display: inline-block;
        width: 144px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #2026CC;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        box-sizing: border-box;
        vertical-align: middle;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/newLive/PaySuc.vue